export const PLACEMENT_STATUS_LOG_TYPES = {
  PENDING: 1,
  ONPROGRESS: 2,
  SUCCESS: 3,
  FAILED: 4,
  SKIPPED_BY_STUDENT: 5,
  SKIPPED_BY_PERFORMANCE: 6,
  REASSIGNED: 7,
}
